export default {
    ADD_MESSAGE: 'ADD_MESSAGE',
    EDIT_MESSAGE: 'EDIT_MESSAGE',
    DELETE_MESSAGE: 'DELETE_MESSAGE',
    UPDATE_FULL_MESSAGES: 'UPDATE_FULL_MESSAGES',
    RESET_MESSAGES: 'RESET_MESSAGES'
};
